module.exports = __webpack_public_path__ + "img/debtPayingAbility3.fa66cbc6.png";